export function callNativeAlert(message: string) {
  alert(message)
}
